module.exports = __webpack_public_path__ + "img/drawer-shapes.b53c0fb3.svg";